import { useEffect, useState } from "react";

import KnowledgeDocumentForm from "../components/KnowledgeDocumentForm";
import useAdminService from "../hooks/useAdminService";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKButton from "components/MKButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";

function ExistingKnowledgeDocument({ knowledgeDocumentId }) {
  const { getKnowledgeDocumentById, loading, deleteKnowledgeDocumentById } = useAdminService();
  const [knowledgeDocument, setKnowledgeDocument] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchKnowledgeDocument = async () => {
      const response = await getKnowledgeDocumentById(knowledgeDocumentId);
      if (response.error) {
        console.error(response.error);
      } else {
        const documentData = {
          id: response.id,
          subject: response.subject,
          summary: response.summary,
          content: response.content,
        };
        setKnowledgeDocument(documentData);
      }
    };
    fetchKnowledgeDocument();
  }, [knowledgeDocumentId]);

  const handleDelete = async (e) => {
    e.preventDefault();
    const confirm = window.confirm(
      "Weet je zeker dat je dit kennisdocument wilt verwijderen? Dit kan niet ongedaan worden"
    );
    if (confirm) {
      const response = await deleteKnowledgeDocumentById(knowledgeDocumentId);
      if (response.error) {
        console.error(response.error);
      } else {
        navigate("/admin/agents");
      }
    }
  };

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <MKBox component="section" py={12}>
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MKBox display="flex" justifyContent="flex-end" mb={2}>
              <Tooltip
                title="Verwijder dit kennisdocument permanent uit de database."
                placement="left"
              >
                <MKButton variant="gradient" color="dark" onClick={handleDelete}>
                  <DeleteIcon sx={{ mr: 1 }} /> Verwijderen
                </MKButton>
              </Tooltip>
            </MKBox>
          </Grid>

          <Grid item xs={12}>
            <MKTypography variant="h3" gutterBottom>
              Bewerk bestaand kennisdocument.
            </MKTypography>
            <MKTypography variant="body2" fontWeight="regular" color="text">
              Een kennis document is een document dat informatie bevat over een bepaald onderwerp.
              Het kan bijvoorbeeld een handleiding, een technische specificatie of een andere
              relevante informatie zijn.
            </MKTypography>
          </Grid>
          <Grid item xs={12}>
            {knowledgeDocument ? (
              <KnowledgeDocumentForm knowledgeDocument={knowledgeDocument} />
            ) : (
              <CircularProgress />
            )}
          </Grid>
        </Grid>
      </Container>
    </MKBox>

    // <div>
    //   {error && <div>{error}</div>}
    //   {knowledgeDocument && <KnowledgeDocumentForm knowledgeDocument={knowledgeDocument} />}
    // </div>
  );
}

export default ExistingKnowledgeDocument;

ExistingKnowledgeDocument.propTypes = {
  knowledgeDocumentId: PropTypes.string.isRequired,
};
